import React, { useState } from 'react';

const regions = [
  { id: 'ams', name: 'Amsterdam', x: 570, y: 275 },
  { id: 'atl', name: 'Atlanta', x: 310, y: 344 },
  { id: 'blr', name: 'Bangalore', x: 768, y: 435 },
  { id: 'bom', name: 'Mumbai', x: 752, y: 412 },
  { id: 'cdg', name: 'Paris', x: 559, y: 291 },
  { id: 'del', name: 'Delhi NCR', x: 762, y: 392 },
  { id: 'dfw', name: 'Dallas', x: 278, y: 344 },
  { id: 'ewr', name: 'New Jersey', x: 325, y: 321 },
  { id: 'fra', name: 'Frankfurt', x: 592, y: 280 },
  { id: 'hnl', name: 'Honolulu', x: 109, y: 382 },
  { id: 'icn', name: 'Seoul', x: 908, y: 323 },
  { id: 'itm', name: 'Osaka', x: 934, y: 331 },
  { id: 'jnb', name: 'Johannesburg', x: 625, y: 549 },
  { id: 'lax', name: 'Los Angeles', x: 212, y: 353 },
  { id: 'lhr', name: 'London', x: 548, y: 274 },
  { id: 'mad', name: 'Madrid', x: 536, y: 313 },
  { id: 'man', name: 'Manchester', x: 538, y: 265 },
  { id: 'mel', name: 'Melbourne', x: 957, y: 592 },
  { id: 'mex', name: 'Mexico City', x: 255, y: 396 },
  { id: 'mia', name: 'Miami', x: 324, y: 373 },
  { id: 'nrt', name: 'Tokyo', x: 944, y: 317 },
  { id: 'ord', name: 'Chicago', x: 286, y: 319 },
  { id: 'sao', name: 'São Paulo', x: 417, y: 552 },
  { id: 'scl', name: 'Santiago', x: 341, y: 599 },
  { id: 'sea', name: 'Seattle', x: 198, y: 287 },
  { id: 'sgp', name: 'Singapore', x: 829, y: 445 },
  { id: 'sjc', name: 'Silicon Valley', x: 197, y: 324 },
  { id: 'sto', name: 'Stockholm', x: 584, y: 247 },
  { id: 'syd', name: 'Sydney', x: 973, y: 572 },
  { id: 'tlv', name: 'Tel Aviv', x: 644, y: 354 },
  { id: 'waw', name: 'Warsaw', x: 608, y: 269 },
  { id: 'yto', name: 'Toronto', x: 302, y: 276 }
];

const WorldMapRegions = () => {
  const [hoveredRegion, setHoveredRegion] = useState(null);

  return (
    <div className="relative w-full bg-[#111827] py-10 text-center overflow-hidden">
      <h2 className="text-3xl font-bold text-white mb-6">Deploy Globally from 32 Regions</h2>

      <div className="relative w-full max-w-[1152px] mx-auto">
        <img
          src="/images/world-map.png"
          alt="World Map"
          className="w-full h-auto"
        />

        {regions.map((region, index) => (
          <div
            key={index}
            className="absolute"
            style={{
              top: region.y,
              left: region.x,
              transform: 'translate(-50%, -50%)'
            }}
            onMouseEnter={() => setHoveredRegion(region.id)}
            onMouseLeave={() => setHoveredRegion(null)}
          >
            {/* 🔴 Always show red marker */}
            <div className="w-3 h-3 bg-red-500 rounded-full"></div>

            {/* 💬 Tooltip only on hover */}
            {hoveredRegion === region.id && (
              <div className="absolute z-50 top-[-10rem] left-1/2 transform -translate-x-1/2 w-56 p-4 bg-white shadow-xl border rounded-md text-center">
                <img
                  src={`/images/regions/${region.id}.png`}
                  alt={region.name}
                  className="w-full h-24 object-contain mb-2"
                />
                <div className="text-gray-800 font-semibold text-sm">{region.name}</div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorldMapRegions;
